import { usePlanSaleStartBeforeDate as useSaleStartBeforeDate } from "@/components/features/items/edit/plan/_shared/ui/components/term/sale-start-before-date/hooks";

import { useProductPlanFormModelContext } from "../../../../context";

export const usePlanSaleStartBeforeDate = () => {
	const { viewModel, onSetViewModel } = useProductPlanFormModelContext();
	const { saleStartBeforeDate } = viewModel;

	return useSaleStartBeforeDate({
		saleStartBeforeDate,
		onSetViewModel,
	});
};
